import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ROOM_STATUS } from 'constants/index';
import { ClientRoomData } from 'models/room/interface';

import * as actions from './actions';

type Room = {
  roomData: ClientRoomData | null;
  isBusy: boolean;
};

const initialState: Room = {
  roomData: null,
  isBusy: false,
};

export const Room = createSlice({
  name: 'room',
  initialState,
  reducers: {
    setRoomData: (state, action: PayloadAction<ClientRoomData | null>) => {
      state.roomData = action.payload;
    },
    setRoomStatus: (state, action: PayloadAction<ROOM_STATUS>) => {
      if (state.roomData) state.roomData.status = action.payload;
    },
    setRoomStartedAt: (state, action: PayloadAction<ClientRoomData['startedAt']>) => {
      if (state.roomData) state.roomData.startedAt = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(actions.setListenerHistory.pending, (state) => {
      state.isBusy = true;
    });
    builder.addCase(actions.setListenerHistory.fulfilled, (state) => {
      state.isBusy = false;
    });
    builder.addCase(actions.setListenerHistory.rejected, (state) => {
      state.isBusy = false;
    });
  },
});

export const { setRoomData, setRoomStatus, setRoomStartedAt } = Room.actions;
export default Room.reducer;
